import {
  APP_INIT,
  UPDATE_CURRENT_PAGE,
  UpdateCurrentPageAction
} from 'components/Pagelayout/actions';
import { PageState } from 'models/PageState';
import {
  getAddFavouriteEvent,
  getCopyProductTitleEvent,
  getLoginEvent,
  getInstallationZipCodeEvent,
  getNavigationEvent,
  getPageViewEvent,
  getSearchEvent,
  getRemoveFavouriteEvent,
  getSelectItemEvent,
  getSelectPromotionEvent,
  getViewCartEvent,
  getViewItemEvent,
  getViewListItemEvent,
  getViewMoreProductsEvent,
  getViewPromotionEvent,
  getViewPromotionListEvents,
  getNewsletterModalLaterEvent,
  getNewsletterModalDeclineEvent,
  getNewsletterSignupEvent,
  getQuotationRequestEvent,
  getQuotationRequestSubmitEvent,
  getFaqClickEvent,
  getSelectedCategoryEvent,
  getSelectedQuestionEvent,
  getPopularCategoryNavEvent,
  getSubmitFormEvent,
  getEditQuantityEvent,
  getViewGroupAddonEvent,
  getViewPriceMatchGuaranteeEvent
} from 'store/googleTagManager/events';
import {
  PRODUCT_PAGE_LOADED,
  PRODUCT_PAGE_VARIANT_DATA_SET,
  ProductPageVariantDataAction
} from 'views/ProductPage/actions';
import { isProductPage, ProductPageModel } from 'models/ProductPageModel';
import {
  DRAWER_PRODUCT_SET_PRODUCT,
  SetDrawerProductAction
} from 'views/ProductPage/drawerProduct/reducer';
import { HeaderState } from 'models/HeaderState';
import { EventsMap as EventsMapType } from 'redux-beacon';
import { getClearCartEvent } from 'store/googleTagManager/events';
import {
  GTM_ADD_FAVOURITE,
  GTM_CLEAR_CART,
  GTM_COPY_PRODUCT_TITLE,
  GTM_LOGIN,
  GTM_REMOVE_FAVOURITE,
  GTM_SELECT_ITEM,
  GTM_SELECT_PROMOTION,
  GTM_VIEW_CART,
  GTM_VIEW_LIST_ITEM,
  GTM_VIEW_MORE_PRODUCTS,
  GTM_VIEW_PROMOTION,
  GtmCopyProductNameAction,
  GtmFavouriteAction,
  GtmItemAction,
  GtmNewsletterSignupAction,
  GtmPromotionAction,
  NEWSLETTER_MODAL_DECLINE,
  NEWSLETTER_MODAL_LATER,
  NEWSLETTER_SIGNUP,
  GtmViewItemAction,
  GTM_FILTER_CHANGE,
  GTM_SEARCH,
  GtmSearchAction,
  InstallationZipCodeAction,
  INSTALLATION_ZIP_CODE,
  GTM_INTERNAL_NAV_CLICK,
  GtmInternalNavAction,
  GTM_FOOTER_NAV_CLICK,
  GTM_VIEW_THECA_PROMOTION,
  GTM_SELECT_THECA_PROMOTION,
  GtmThecaPromotionAction,
  GTM_QUOTATION,
  GTM_QUOTATION_SUBMIT,
  GtmQuotationRequestAction,
  GTM_HELP_CENTER_FAQ,
  GTM_HELP_CENTER_CATEGORY,
  GTM_HELP_CENTER_QUESTION,
  GtmHelpCenterCategoryAction,
  GtmHelpCenterFaqAction,
  GtmHelpCenterQuestionAction,
  GTM_CUSTOMER_SUPPORT_FORM_SUBMIT,
  GtmQuantityAction,
  GTM_VIEW_GROUP_ADDON,
  GtmViewGroupAddonAction,
  GtmCustomerSupportAction,
  GTM_POPULAR_CATEGORY_NAV,
  GtmPopularCategoryNavAction,
  GTM_EDIT_QUANTITY,
  GTM_VIEW_PRICE_MATCH_GUARANTEE
} from 'store/googleTagManager/actions';

export const EventsMap: EventsMapType = {
  [APP_INIT]: function (_, state: PageState) {
    // Page view event for product pages are handled in [PRODUCT_PAGE_LOADED], to avoid duplicate events
    if (isProductPage(state.currentPage)) {
      return;
    }

    return getPageViewEvent(state.currentPage);
  },
  [PRODUCT_PAGE_LOADED]: function (_, state: PageState) {
    const currentPage = state.currentPage as ProductPageModel;

    const pageViewEvent = getPageViewEvent(currentPage);
    const viewItemEvent = getViewItemEvent(
      currentPage.product,
      state.appShell.currencyCode,
      currentPage.addons
    );
    return [pageViewEvent, viewItemEvent];
  },
  [DRAWER_PRODUCT_SET_PRODUCT]: function (action: SetDrawerProductAction, state: HeaderState) {
    return getViewItemEvent(action.product, state.appShell.currencyCode, action.addons);
  },
  [UPDATE_CURRENT_PAGE]: function (action: UpdateCurrentPageAction) {
    // Page view event for product pages are handled in [PRODUCT_PAGE_LOADED], to avoid duplicate events
    if (isProductPage(action.newPage)) {
      return;
    }

    return getPageViewEvent(action.newPage);
  },
  [PRODUCT_PAGE_VARIANT_DATA_SET]: function (
    action: ProductPageVariantDataAction,
    state: HeaderState
  ) {
    const pageViewEvent = getPageViewEvent(state.currentPage);
    const viewItemEvent = getViewItemEvent(
      action.data.product,
      state.appShell.currencyCode,
      action.data.addons
    );

    return [pageViewEvent, ...viewItemEvent];
  },
  [INSTALLATION_ZIP_CODE]: function (action: InstallationZipCodeAction) {
    return getInstallationZipCodeEvent(action);
  },
  [NEWSLETTER_MODAL_LATER]: function () {
    return getNewsletterModalLaterEvent();
  },
  [NEWSLETTER_MODAL_DECLINE]: function () {
    return getNewsletterModalDeclineEvent();
  },
  [NEWSLETTER_SIGNUP]: (action: GtmNewsletterSignupAction) => {
    return getNewsletterSignupEvent(action.signupPlacement);
  },
  [GTM_CLEAR_CART]: () => {
    return getClearCartEvent();
  },
  [GTM_SELECT_ITEM]: (action: GtmItemAction, prevState: PageState) => {
    return getSelectItemEvent(action, prevState.appShell.currencyCode);
  },
  [GTM_VIEW_LIST_ITEM]: (action: GtmViewItemAction, prevState: PageState) => {
    return getViewListItemEvent(action, prevState.appShell.currencyCode);
  },
  [GTM_VIEW_PROMOTION]: (action: GtmPromotionAction, prevState: PageState) => {
    return getViewPromotionEvent(action, prevState);
  },
  [GTM_SELECT_PROMOTION]: (action: GtmPromotionAction, prevState: PageState) => {
    return getSelectPromotionEvent(action, prevState);
  },
  [GTM_VIEW_THECA_PROMOTION]: (action: GtmThecaPromotionAction, prevState: PageState) => {
    return getViewPromotionListEvents(action, prevState);
  },
  [GTM_SELECT_THECA_PROMOTION]: (action: GtmPromotionAction, prevState: PageState) => {
    return getSelectPromotionEvent(action, prevState);
  },
  [GTM_ADD_FAVOURITE]: (action: GtmFavouriteAction, prevState: PageState) => {
    return getAddFavouriteEvent(action, prevState.appShell.currencyCode);
  },
  [GTM_VIEW_CART]: (_, prevState: PageState) => {
    return getViewCartEvent(prevState);
  },
  [GTM_COPY_PRODUCT_TITLE]: ({ productId, title }: GtmCopyProductNameAction) => {
    return getCopyProductTitleEvent(title, productId);
  },
  [GTM_FILTER_CHANGE]: (_, prevState: PageState) => {
    return getPageViewEvent(prevState.currentPage);
  },
  [GTM_SEARCH]: (action: GtmSearchAction) => {
    return getSearchEvent(action);
  },
  [GTM_REMOVE_FAVOURITE]: (action: GtmFavouriteAction, prevState: PageState) => {
    return getRemoveFavouriteEvent(action, prevState.appShell.currencyCode);
  },
  [GTM_LOGIN]: () => {
    return getLoginEvent();
  },
  [GTM_VIEW_MORE_PRODUCTS]: () => {
    return getViewMoreProductsEvent();
  },
  [GTM_INTERNAL_NAV_CLICK]: (action: GtmInternalNavAction, prevState: PageState) => {
    return getNavigationEvent(action, prevState.appShell, 'internal_navigation');
  },
  [GTM_FOOTER_NAV_CLICK]: (action: GtmInternalNavAction, prevState: PageState) => {
    return getNavigationEvent(action, prevState.appShell, 'footer_navigation');
  },
  [GTM_QUOTATION]: (action: GtmQuotationRequestAction) => {
    return getQuotationRequestEvent(action);
  },
  [GTM_QUOTATION_SUBMIT]: () => {
    return getQuotationRequestSubmitEvent();
  },
  [GTM_HELP_CENTER_FAQ]: ({ question }: GtmHelpCenterFaqAction) => {
    return getFaqClickEvent(question);
  },
  [GTM_HELP_CENTER_CATEGORY]: ({ category }: GtmHelpCenterCategoryAction) => {
    return getSelectedCategoryEvent(category);
  },
  [GTM_HELP_CENTER_QUESTION]: ({ category, question }: GtmHelpCenterQuestionAction) => {
    return getSelectedQuestionEvent(category, question);
  },
  [GTM_CUSTOMER_SUPPORT_FORM_SUBMIT]: (action: GtmCustomerSupportAction, prevState: PageState) => {
    return getSubmitFormEvent(action.form, prevState.currentPage.componentName);
  },
  [GTM_EDIT_QUANTITY]: (action: GtmQuantityAction, prevState: PageState) => {
    return getEditQuantityEvent(action, prevState.appShell.currencyCode);
  },
  [GTM_VIEW_GROUP_ADDON]: (action: GtmViewGroupAddonAction) => {
    return getViewGroupAddonEvent(action);
  },
  [GTM_POPULAR_CATEGORY_NAV]: (action: GtmPopularCategoryNavAction, prevState: PageState) => {
    return getPopularCategoryNavEvent(action, prevState.appShell);
  },
  [GTM_VIEW_PRICE_MATCH_GUARANTEE]: () => {
    return getViewPriceMatchGuaranteeEvent();
  }
};
